import VStack from "@/components/Layout/VStack";
import { Outlet, createFileRoute } from "@tanstack/react-router";
import Header from "./-layout/Header";

export const Route = createFileRoute("/_staff/software/$id/_$id")({
  component: Layout,
});

export default function Layout() {
  return (
    <VStack>
      <Header />
      <Outlet />
    </VStack>
  );
}
